var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Line icon Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99987 1.59998C7.55804 1.59998 7.19987 1.95815 7.19987 2.39998V7.19998H2.39961C1.95778 7.19998 1.59961 7.55815 1.59961 7.99998C1.59961 8.4418 1.95778 8.79998 2.39961 8.79998H7.19987V13.6C7.19987 14.0418 7.55804 14.4 7.99987 14.4C8.4417 14.4 8.79987 14.0418 8.79987 13.6V8.79998H13.5996C14.0414 8.79998 14.3996 8.4418 14.3996 7.99998C14.3996 7.55815 14.0414 7.19998 13.5996 7.19998H8.79987V2.39998C8.79987 1.95815 8.4417 1.59998 7.99987 1.59998Z",
    fill: "black",
    fillOpacity: 0.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddThumbnail);
export default __webpack_public_path__ + "static/media/addThumbnail.76339c8bf9d04c08dffb1a33af565bc7.svg";
export { ForwardRef as ReactComponent };